import SectionHeading from '@/components/feature/SectionHeading';
import { themes } from '@/mocks/home';

export default function Themes() {
  return (
    <section id="themes" className="w-full bg-background-100 py-14 md:py-20">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <SectionHeading
          eyebrow="Highlights"
          title="核心看点：它靠什么抓住你"
          desc="从结构、节奏到氛围，六个方向帮你判断这部剧是否符合你的口味。"
          align="center"
        />

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {themes.map((t, i) => (
            <article
              key={t.title}
              className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6 flex flex-col gap-3"
            >
              <span
                className={`w-11 h-11 flex items-center justify-center rounded-lg ${
                  i % 3 === 1 ? 'bg-accent-100 text-accent-700' : 'bg-primary-100 text-primary-700'
                }`}
              >
                <i className={`${t.icon} text-xl`} aria-hidden="true" />
              </span>
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950">{t.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{t.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}